import type { User } from '@repo-level/core-front';
import { addPlayerGroups } from 'api/auth';
import { fetchRiskSegment } from 'api/bqApi';

const RISK_SEGMENT_PREFIX = 'risk-segment:';
const VALID_SEGMENT = /^S([1-9]|10)$/;
const DEFAULT_SEGMENT_ID = 'S10';

export const syncRiskSegment = async (
  user: Pick<User, 'id' | 'statuses'>,
  refreshUser: () => Promise<unknown>
): Promise<void> => {
  if (!user?.id) return;

  const segment = await fetchRiskSegment(user.id);

  const segmentId =
    segment?.segment_id && VALID_SEGMENT.test(segment.segment_id)
      ? segment.segment_id
      : DEFAULT_SEGMENT_ID;

  const desiredGroup = `${RISK_SEGMENT_PREFIX}${segmentId}`;

  if (user.statuses?.some(({ id }) => id === desiredGroup)) return;

  try {
    await addPlayerGroups([desiredGroup]);
    await refreshUser();
  } catch (e) {
    console.warn('syncRiskSegment: addPlayerGroups failed:', e);
  }
};
